<template>
    <div class="doctor-detail">
        <div class="first-row">
            <div class="doctor-detail__content-item">
                <img :src="data.photo ? data.photo.crop : ''"
                     alt="Котелин Игорь Владиславович">
                <div class="doctor-detail__description">
                    <h3>{{ data.full_name }}</h3>
                    <div>
                        <h5 v-html="data.short_description"/>
                        <h5 v-if="data.academic_degree" v-html="data.academic_degree"/>
                        <h5 v-if="data.category" v-html="data.category"/>
                    </div>
                    <div v-if="data.is_department_head" class="doctor-detail__main">
                        <h6>Заведующий отделением</h6>
                    </div>
                </div>
            </div>
            <div class="doctor-detail__button-wrapper">
                <button @click="$emit('openContact', 'sendFeedback')">Оставить отзыв</button>
                <button v-if="data.email" @click="$emit('openContact', 'askQuestion')">Задать вопрос врачу</button>
            </div>
        </div>
        <div class="second-row">
            <div class="doctor-detail__title">
                {{ data.full_name }}
            </div>
            <div v-html="data.description" class="doctor-detail__content"/>
        </div>
    </div>
</template>

<script>
export default {
    props: ["data"]
}
</script>

<style lang="scss" scoped>
.doctor-detail {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-column-gap: 5%;
    max-width: 1000px;
    padding: 50px 20px;
    background-color: #FFF;
    min-width: 990px;

    @media screen and (max-width: 1300px) {
        min-width: 80%;
    }

    @media screen and (max-width: 990px) {
        min-width: unset;
    }

    @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }

    &__content {
        text-align: left;
        font: normal 14px/16px Arial, sans-serif;
        color: #707070;
        max-height: 65vh;
        overflow-y: auto;
        padding-right: 15px;

        @media screen and (max-width: 560px) {
            max-height: 300px;
        }

        &::-webkit-scrollbar {
            background: unset;
            width: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(0, 182, 204, 0.68);
            border-radius: 6px;
        }

        strong {
            font-weight: Bold;
            color: #131313;
            padding: 10px 0;
            line-height: 28px;
        }
    }

    &__content-item {
        img {
            width: 224px;
            height: 224px;
            border-radius: 50%;
            padding-bottom: 10px;
        }
    }

    &__title {
        font: Bold 18px/12px Arial, sans-serif;
        color: #131313;
        padding: 20px 0;
        text-align: left;
    }

    &__description {
        h3 {
            font: normal 14px/12px Arial, sans-serif;
            letter-spacing: 0px;
            color: #131313;
        }

        h5 {
            padding: 6px 0;
            color: #666 !important;
        }

        h5:first-child {
            padding-top: 15px;
        }

        h5:last-child {
            padding-bottom: 15px;
        }

        h5, &__main {
            font: normal 12px/12px Arial, sans-serif;
            letter-spacing: 0px;
            color: #131313;
        }
    }

    &__main {
        h6 {
            font: normal 12px/12px Arial, sans-serif;
            color: #131313;
            display: flex;
            align-items: center;
            justify-content: center;

            &:before {
                content: '';
                display: block;
                margin-right: 10px;
                height: 12px;
                width: 3px;
                background: #00B6CC;

            }
        }
    }

    &__button-wrapper {
        margin-top: 30px;
        display: block;

        button {
            display: block;
            padding: 8px 0 7px 0;
            min-width: 185px;
            background-color: #006687;
            color: #ffffff;
            margin: 15px auto;
            border-radius: 1px;
        }
    }
}
</style>

<style>
.popup-content-wrapper strong {
    line-height: 25px;
}
</style>